<template>
  <b-modal
    id="retur-modal"
    title="Form Request Pengembalian"
    centered
    @show="onShow"
    @hidden="resetForm"
  >
    <p class="text-body mb-2">
      Lengkapi tanggal dan gudang tujuan sebelum mengirim request.
    </p>

    <b-form-group label="Jumlah Item" label-for="retur-jumlah-item">
      <b-form-input
        id="retur-jumlah-item"
        disabled
        :value="items.length"
      />
    </b-form-group>

    <b-form-group label="Tanggal" label-for="retur-tanggal">
      <b-form-input
        id="retur-tanggal"
        v-model="form.tanggal"
        type="date"
        :state="tanggalState"
      />
      <small v-if="tanggalState === false" class="text-danger">
        Tanggal wajib diisi
      </small>
    </b-form-group>

    <b-form-group label="Pilih Gudang" label-for="retur-gudang">
      <b-form-select
        id="retur-gudang"
        v-model="form.id_gudang"
        :options="gudangOptions"
        :state="gudangState"
      />
      <small v-if="gudangState === false" class="text-danger">
        Gudang wajib dipilih
      </small>
    </b-form-group>

    <b-form-group label="Keterangan (opsional)" label-for="retur-keterangan">
      <b-form-textarea
        id="retur-keterangan"
        v-model="form.keterangan"
        rows="3"
        placeholder="Catatan pengembalian..."
      />
    </b-form-group>

    <div
      v-if="invalidItems.length"
      class="alert alert-danger py-1 px-2 mb-0"
    >
      Qty pengembalian tidak valid untuk:
      <ul class="mb-0 pl-2">
        <li v-for="(item, idx) in invalidItems" :key="idx">
          {{ item.nama || item.id_barang }}
        </li>
      </ul>
    </div>

    <template #modal-footer="{ cancel }">
      <div class="d-flex justify-content-end w-100">
        <b-button
          variant="outline-secondary"
          class="mr-1"
          :disabled="saving"
          @click="cancel()"
        >
          Batal
        </b-button>
        <b-button
          variant="primary"
          :disabled="saving || !!invalidItems.length"
          @click.prevent="submit"
        >
          <b-spinner v-if="saving" small class="mr-50" />
          Request Pengembalian
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import {
  BModal,
  BFormGroup,
  BButton,
  BFormInput,
  BFormTextarea,
  BFormSelect,
  BSpinner,
} from "bootstrap-vue";

export default {
  components: {
    BModal,
    BFormGroup,
    BButton,
    BFormInput,
    BFormTextarea,
    BFormSelect,
    BSpinner,
  },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    saving: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      form: {
        tanggal: null,
        keterangan: null,
        id_sales: null,
        id_gudang_m: null,
        id_gudang: null,
      },
      gudangOptions: [],
      touched: false,
    };
  },
  computed: {
    invalidItems() {
      return (this.items || []).filter((barang) => {
        const qty = Number(barang.jumlah_retur);
        const stok = Number(barang.stok) || 0;
        return !qty || qty < 1 || qty > stok;
      });
    },
    tanggalState() {
      if (!this.touched) return null;
      return this.form.tanggal ? true : false;
    },
    gudangState() {
      if (!this.touched) return null;
      return this.form.id_gudang ? true : false;
    },
  },
  methods: {
    onShow() {
      this.touched = false;
      this.resetForm();
      if (!this.gudangOptions.length) {
        this.getDataGudang1();
      }
    },
    resetForm() {
      this.form = {
        tanggal: this.getCurrentDate(),
        keterangan: null,
        id_sales: null,
        id_gudang_m: null,
        id_gudang: null,
      };
      this.touched = false;
    },
    submit() {
      this.touched = true;

      if (!this.form.tanggal || !this.form.id_gudang) {
        this.displayError({
          message: "Harap isi tanggal dan pilih gudang tujuan.",
        });
        return false;
      }

      if (this.invalidItems.length) {
        this.displayError({
          message:
            "Qty pengembalian harus lebih dari 0 dan tidak melebihi stok.",
        });
        return false;
      }

      this.form.id_sales = this.user.karyawan.id;
      this.form.id_gudang_m = this.myGudang.id;

      const payloads = this.items.map((barang) => ({
        id_pengembalian: null,
        id_barang: barang.id_barang,
        qty: Number(barang.jumlah_retur),
      }));

      this.$emit("submit", {
        pengembalian: { ...this.form },
        rincian: payloads,
        done: () => {
          this.resetForm();
        },
      });
    },
    async getDataGudang1() {
      try {
        await this.$store.dispatch("gudang/getData", { jenis: 1 });
        const gudang = JSON.parse(
          JSON.stringify(this.$store.state.gudang.datas || [])
        );
        gudang.forEach((item) => {
          item.value = item.id;
          item.text = item.nama_gudang;
        });
        this.gudangOptions = gudang;
      } catch (e) {
        this.displayError(e);
      }
    },
  },
};
</script>
